import { BLUE_GREY_100, BLUE_GREY_200, BLUE_GREY_300, LILAC_200, LILAC_300, LILAC_400, TRANSPARENT, WHITE } from '../colors';
var dropdownConfig = {
  dropdownList: [],
  label: '',
  controlState: 'none',
  position: 'below',
  config: {
    dropdownMenuBorderColor: WHITE,
    controlState: {
      none: {
        backgroundColor: TRANSPARENT
      },
      hover: {
        backgroundColor: LILAC_300
      },
      pressed: {
        backgroundColor: LILAC_400
      },
      disabled: {
        backgroundColor: LILAC_200
      }
    }
  }
};
var whiteTheme = Object.assign(Object.assign({}, dropdownConfig), {
  config: {
    dropdownMenuBorderColor: BLUE_GREY_200,
    controlState: {
      none: {
        backgroundColor: WHITE
      },
      hover: {
        backgroundColor: BLUE_GREY_200
      },
      pressed: {
        backgroundColor: BLUE_GREY_300
      },
      disabled: {
        backgroundColor: BLUE_GREY_100
      }
    }
  }
});
export default {
  light: dropdownConfig,
  dark: dropdownConfig,
  white: whiteTheme
};